export default __webpack_public_path__ + "static/reed-4--mobile-428580e48dce6ab78c57821651e7a05f.webp";